import { FootnoteIndicatorService } from '@trp-dms-pop/product-component-library-components/common';

export class FootnoteIndicatorOrchestration {
  constructor() {
    // Intentionally Empty
  }

  public loadFootnoteIndicatorService(): void {
    this.onLoadPromise().then(() => {
      const footnoteIndicatorService = new FootnoteIndicatorService();
      footnoteIndicatorService.applyFootnoteIndicatorsToAll();
    });
  }

  private onLoadPromise(): Promise<[void, void] | void> {
    const onload = new Promise<void>((resolve) => {
      if (document.readyState !== 'complete') {
        window.addEventListener(
          'load',
          () => {
            resolve();
          },
          { once: true },
        );
      } else {
        resolve();
      }
    });

    if (!('requestIdleCallback' in window)) {
      // run immediately
      return onload;
    }

    // both idle and onload
    return Promise.all([
      new Promise<void>((resolve) => {
        requestIdleCallback(() => {
          resolve();
        });
      }),
      onload,
    ]);
  }
}
